import { useState } from "react";
import { useFilterContext } from '../components/FilterContext';
import { useResetContext } from '../components/ResetContext';

const useChargingOverviewQuery = () => {
  const [chargingOverviewData, setChargingOverviewData] = useState(null);
  const { filterdata } = useFilterContext();
  const { resetdata } = useResetContext();

  const fetchChargingOverview = async ({ vin_short, date, category }) => {
    try {
      let baseURL;

      if (window.location.hostname === "simbaanalytics-dev.rio.cloud") {
        baseURL = "https://26ovsbph5oz6xpn2fgscmr5x5i0socao.lambda-url.eu-west-1.on.aws";
      } else if (window.location.hostname === "bev-dev.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://spv3toxlwj.execute-api.eu-west-1.amazonaws.com/test_cognito";
      } else if (window.location.hostname === "bev-prod.simbaanalytics-dev.rio.cloud") {
        baseURL = "https://dnz0zln7l2.execute-api.eu-west-1.amazonaws.com/prod";
      } else {
        baseURL = "http://localhost:8080";
      }

      const token = localStorage.getItem("idToken");
      if (!token) {
        console.error("No ID token found!");
        return null;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await fetch(`${baseURL}/get-charging-overview`, {
        method: "POST",
        headers,
        body: JSON.stringify({ vin_short, date, category, filterdata, resetdata }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setChargingOverviewData(result);
      return result;
    } catch (error) {
      console.error("Error fetching charging overview data:", error);
      return null;
    }
  };

  return { chargingOverviewData, fetchChargingOverview };
};

export default useChargingOverviewQuery;